import React from 'react';
import { Button, ModalIsland } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../hooks';

import { externalLinkWarningMessages } from './externalLinkWarningMessages';

export interface ExternalLinkWarningModalTestIds {
  modal: string;
  continueButton: string;
  cancelButton: string;
}

interface ExternalLinkWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  testIds: ExternalLinkWarningModalTestIds;
}

function ExternalLinkWarningModal({
  isOpen,
  onClose,
  onContinue,
  testIds: testIdProps,
}: ExternalLinkWarningModalProps) {
  const l = useInvertedLocalize(externalLinkWarningMessages);

  return (
    <ModalIsland
      kind='warning'
      alertTitle={l('External Link')}
      alertSubtitle={l(
        'You are about to open an external link. Do you want to continue?'
      )}
      isOpen={isOpen}
      onClose={onClose}
      primaryButton={
        <Button
          kind='filled'
          size='medium'
          onClick={onContinue}
          dataTestId={testIdProps.continueButton}>
          {l('Continue')}
        </Button>
      }
      secondaryButton={
        <Button
          kind='ghost'
          size='medium'
          onClick={onClose}
          dataTestId={testIdProps.cancelButton}>
          {l('Cancel')}
        </Button>
      }
      dataTestId={testIdProps.modal}
    />
  );
}

export default ExternalLinkWarningModal;
